const API_URL = process.env.REACT_APP_API_URL
const auth = JSON.parse(localStorage.getItem("kt-auth-react-v")!);

// Define a function that logs information
const logAction = async (currentUser: any, fileId: any) => {
    const params = {user: currentUser, action: fileId}
    try {
      const response = await fetch(`${API_URL}/log/addLog/`, {
        method: 'POST',
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params)
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
    } catch (err) {
      //console.log(err)
    }
}

export default logAction;
